// test1210
(1210 && 0);
